import React, { useState } from "react";
import Header from "../../../layouts/Header";
import Sidebar from "../../../layouts/Sidebar";

const AddTask = () => {
  const [menu, setMenu] = useState(false);

  const [formData, setFormData] = useState({
    Client: "",
    ServiceAct: "",
    Service: "",
    Frequency: "",
    FinancialYear: "",
    Period: "",
    AssignedTo: "",
    Status: "",
    Priority: "",
    StartDate: "",
    PinCode: "",
    DueDate: "",
    Amount: "",
    Penalty: "",
    UserState: "",
    BranchCode: "",
  });

  const [validation, setValidation] = useState({
    Client: { isValid: true, message: "" },
    ServiceAct: { isValid: true, message: "" },
    Service: { isValid: true, message: "" },
    Frequency: { isValid: true, message: "" },
    FinancialYear: { isValid: true, message: "" },
    Period: { isValid: true, message: "" },
    AssignedTo: { isValid: true, message: "" },
    PinCode: { isValid: true, message: "" },
    Status: { isValid: true, message: "" },
    Priority: { isValid: true, message: "" },
    StartDate: { isValid: true, message: "" },
    DueDate: { isValid: true, message: "" },
    Amount: { isValid: true, message: "" },
    Penalty: { isValid: true, message: "" },
    UserState: { isValid: true, message: "" },
    BranchCode: { isValid: true, message: "" },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const handleSubmitted = (e) => {
    e.preventDefault();

    let isFormValid = true;
    Object.keys(formData).forEach((fieldName) => {
      if (formData[fieldName] === "") {
        isFormValid = false;
        setValidation((prevValidation) => ({
          ...prevValidation,
          [fieldName]: { isValid: false, message: "Field cannot be empty" },
        }));
      }
    });
    let isBillingValid = true;

    if (!isFormValid || !isBillingValid) {
      return;
    }

    console.log(formData);
    console.log(validation);
  };

  const handleInputChange = (fieldName, value) => {
    let isValid = true;
    let message = "";

    if (value === "") {
      isValid = false;
      message = "Field cannot be empty";
    }

    setFormData({
      ...formData,
      [fieldName]: value,
    });

    setValidation({
      ...validation,
      [fieldName]: { isValid, message },
    });
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={(value) => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="p-8">
            <div className="pb-6">
              <h1 className="text-2xl text-black">Create Task</h1>
              <span className="text-red-500">User Side</span>
            </div>
            <form className="w-full">
              <div className="flex flex-wrap -mx-3">
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="Client"
                  >
                    Client <span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.Client.isValid ? "border-red-400" : ""
                      }`}
                      value={formData.Client}
                      onChange={(e) => {
                        handleInputChange("Client", e.target.value);
                      }}
                    >
                      <option>Select Client</option>
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="ServiceAct"
                  >
                    Service Act<span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.ServiceAct.isValid ? "border-red-400" : ""
                      }`}
                      value={formData.ServiceAct}
                      onChange={(e) => {
                        handleInputChange("ServiceAct", e.target.value);
                      }}
                    >
                      <option>Select Service Act</option>
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="Service"
                  >
                    Service<span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.Service.isValid ? "border-red-400" : ""
                      }`}
                      value={formData.Service}
                      onChange={(e) => {
                        handleInputChange("Service", e.target.value);
                      }}
                    >
                      <option>Select Service</option>
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="Frequency"
                  >
                    Frequency<span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.Frequency.isValid ? "border-red-400" : ""
                      }`}
                      value={formData.Frequency}
                      onChange={(e) => {
                        handleInputChange("Frequency", e.target.value);
                      }}
                    >
                      <option>Select Frequency</option>
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="FinancialYear"
                  >
                    Financial Year<span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.FinancialYear.isValid
                          ? "border-red-400"
                          : ""
                      }`}
                      value={formData.FinancialYear}
                      onChange={(e) => {
                        handleInputChange("FinancialYear", e.target.value);
                      }}
                    >
                      <option>Select Year</option>
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="Period"
                  >
                    Period<span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.Period.isValid ? "border-red-400" : ""
                      }`}
                      value={formData.Period}
                      onChange={(e) => {
                        handleInputChange("Period", e.target.value);
                      }}
                    >
                      <option>Select Period</option>
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="AssignedTo"
                  >
                    Assigned To<span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.AssignedTo.isValid ? "border-red-400" : ""
                      }`}
                      value={formData.AssignedTo}
                      onChange={(e) => {
                        handleInputChange("AssignedTo", e.target.value);
                      }}
                    >
                      <option>Select Employee</option>
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="Status"
                  >
                    Status<span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.Status.isValid ? "border-red-400" : ""
                      }`}
                      value={formData.Status}
                      onChange={(e) => {
                        handleInputChange("Status", e.target.value);
                      }}
                    >
                      <option>Select Status</option>
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="Priority"
                  >
                    Priority<span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.Priority.isValid ? "border-red-400" : ""
                      }`}
                      value={formData.Priority}
                      onChange={(e) => {
                        handleInputChange("Priority", e.target.value);
                      }}
                    >
                      <option>Select Priority</option>
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="StartDate"
                  >
                    Start Date<span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.StartDate.isValid ? "border-red-400" : ""
                    }`}
                    type="date"
                    placeholder="Start Date"
                    value={formData.StartDate}
                    onChange={(e) => {
                      handleInputChange("StartDate", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="Due Date"
                  >
                    Due Date<span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.DueDate.isValid ? "border-red-400" : ""
                    }`}
                    type="date"
                    placeholder="Due Date"
                    value={formData.DueDate}
                    onChange={(e) => {
                      handleInputChange("DueDate", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="Amount"
                  >
                    Amount<span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.Amount.isValid ? "border-red-400" : ""
                    }`}
                    type="text"
                    placeholder="Amount"
                    value={formData.Amount}
                    onChange={(e) => {
                      handleInputChange("Amount", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="Penalty"
                  >
                    Penalty
                  </label>
                  <textarea
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.Penalty.isValid ? "border-red-400" : ""
                    }`}
                    name="body"
                    placeholder="Penalty"
                    value={formData.Penalty}
                    onChange={(e) => {
                      handleInputChange("Penalty", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="State"
                  >
                    State
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.UserState.isValid ? "border-red-400" : ""
                      }`}
                      value={formData.UserState}
                      onChange={(e) => {
                        handleInputChange("UserState", e.target.value);
                      }}
                    >
                      <option>Select State</option>
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="BranchCode"
                  >
                    Branch Code
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.BranchCode.isValid ? "border-red-400" : ""
                      }`}
                      value={formData.BranchCode}
                      onChange={(e) => {
                        handleInputChange("BranchCode", e.target.value);
                      }}
                    >
                      <option>Select Branch Code</option>
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap -mx-3">
                <div className="w-full px-3 mb-6">
                  <button
                    onClick={handleSubmitted}
                    className="bg-gray-100 hover:bg-green-300 text-green-700 font-bold border-solid border-2 hover:border-green-400 border-gray-200 py-2 px-4 rounded inline-flex items-center float-right"
                  >
                    <svg
                      className="fill-current"
                      height="20"
                      viewBox="0 0 512 512"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M465.94,119.76l-73.7-73.7h0A47.68,47.68,0,0,0,358.3,32H96A64,64,0,0,0,32,96V416a64,64,0,0,0,64,64H416a64,64,0,0,0,64-64V153.7A47.68,47.68,0,0,0,465.94,119.76ZM120,112H296a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H120a8,8,0,0,1-8-8V120A8,8,0,0,1,120,112ZM259.75,431.91a80,80,0,1,1,76.16-76.16A80.06,80.06,0,0,1,259.75,431.91Z" />
                      <circle cx="256" cy="352" r="48" />
                    </svg>
                    <span className="pl-2">Create Task</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddTask;
